import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { PrescriberIncorrectInformationRequest } from '../models/prescriber-incorrect-information-request.model';
import { PrescriberIncorrectInformationRequestFilters } from '../models/user-settings/prescriber-incorrect-information-request-settings.model';
import { PagedResults } from '../models/paged-results/paged-results.model';
import { LimitOffsetPagingMeta, Sort } from '../models/paged-results/limit-offset-paging.model';
import { environment } from '../../../environments/environment';

export class PagedPrescriberIncorrectInformationRequests implements PagedResults {
  prescriberIncorrectInformationRequests: PrescriberIncorrectInformationRequest[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.prescriberIncorrectInformationRequests;
  }
}

@Injectable()
export class PrescriberIncorrectInformationRequestsService extends ApiService {
  private http = inject(HttpClient);


  getList(
    paging: { page: number; pageSize: number },
    filters: PrescriberIncorrectInformationRequestFilters = null,
    sort: Sort = null
  ): Observable<PagedPrescriberIncorrectInformationRequests> {
    const searchParams = new URLSearchParams(`page=${paging.page}&per_page=${paging.pageSize}`);

    if (filters?.status?.length > 0) {
      filters.status.forEach(v => searchParams.append('status[]', v));
    }

    if (sort?.col) {
      searchParams.append('sort_col', sort.col);
      if (sort.dir) searchParams.append('sort_dir', sort.dir);
    }

    return this.http.get<PagedPrescriberIncorrectInformationRequests>(
      `${environment.captureApi.url}/prescriber_incorrect_information_requests?${searchParams.toString()}`
    );
  }

  create(prescriberIncorrectInformationRequest: {
    clientId: number;
    relatedRecordType: string;
    relatedRecordId: number;
    prescriberId: number;
    comments: string;
  }): Observable<PrescriberIncorrectInformationRequest> {
    return this.http.post<PrescriberIncorrectInformationRequest>(
      `${environment.captureApi.url}/prescriber_incorrect_information_requests`,
      {
        prescriberIncorrectInformationRequest,
      }
    );
  }

  update(
    prescriberIncorrectInformationRequest: PrescriberIncorrectInformationRequest,
    params: { resolved: boolean }
  ): Observable<PrescriberIncorrectInformationRequest> {
    return this.http.patch<PrescriberIncorrectInformationRequest>(
      `${environment.captureApi.url}/prescriber_incorrect_information_requests/${
        prescriberIncorrectInformationRequest.id
      }`,
      params
    );
  }
}
